import { createSlice } from "@reduxjs/toolkit";

const initialSuppliersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  supplier: null,
  supplierForEdit: undefined,
  purchaseReceipts: null,
  purchaseReceipt: null,
  exportURL: null,
  exportStatus: null,
  isDownLoading: false,
  completed: false,
  description: null,
  message: {
    error: null,
    success: null,
    modalError: null,
    modalSuccess: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const suppliersSlice = createSlice({
  name: "suppliers",
  initialState: initialSuppliersState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    endCall: (state, action) => {
      state.actionsLoading = false;
      state.completed = true;
      state.message.success = action.payload.message;
    },
    // findSuppliers
    suppliersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    vendorsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    suppliersPurchaseReceiptFetched: (state, action) => {
      const { entities, item } = action.payload;
      state.purchaseReceipts = entities;
      state.supplier = item;
    },
    // createSupplier
    supplierCreated: (state, action) => {
      state.actionsLoading = false;
      state.completed = true;
      const { message, entity } = action.payload;
      state.message.success = message;
      state.entities = [entity, ...state.entities];
    },
    updateStatus: (state, action) => {
      const { status, url } = action.payload;
      state.exportStatus = status;
      state.exportURL = url;
    },
    updateDownLoadingStatus: (state, action) => {
      state.isDownLoading = action.payload;
    },
    supplierDescription: (state, action) => {
      state.description = action.payload.description;
    },
    selectPurchaseReceipt: (state, action) => {
      state.purchaseReceipt = action.payload.receipt;
    },
    deSelectPurchaseReceipt: (state, action) => {
      state.purchaseReceipts = null;
      state.purchaseReceipt = null;
    },
    //supplier creation/update complete
    changeCompleteStatus: (state, action) => {
      state.message.success = null;
      state.completed = action.payload.status;
    },
    changeMessageResponse: (state) => {
      state.message.error = null;
      // state.message.success = null;
    },
    updateImportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.ImportStatus = status;
      state.ImportUrl = url;
    },
    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
        case "modalError":
          state.message.modalError = message;
          break;
        case "modalSuccess":
          state.message.modalSuccess = message;
          break;
      }
    },
  },
});
